import {useEffect, useMemo, useRef, useState} from "react";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  TextField
} from "@mui/material";
import {ProgressDiv} from "../styles";
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {
  getComparableText,
  getPurchaseNameForDownload,
  getPurchaseNameSummary,
  getWarehouseNameFromState
} from "../stringutils";
import {
  ArrowDropDownOutlined, ArrowForwardIos,
  ArrowRight, ArrowRightAltSharp,
  ClearRounded,
  Done,
  Download,
  InfoSharp,
  LockSharp
} from "@mui/icons-material";
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY, Search, SearchIconWrapper, StyledInputBase} from "../constant";
import moment from "moment";
import CsvDownloader from 'react-csv-downloader';

import {
  addDays,
  endOfDay,
  startOfDay,
  // startOfMonth,
  // endOfMonth,
  // addMonths,
  startOfWeek,
  endOfWeek, startOfMonth, addMonths, endOfMonth,
  // isSameDay,
  // differenceInCalendarDays,
} from 'date-fns';
import {MobileDateRangePicker} from "@mui/lab";
import {useScrollRestore} from "../utils/ScrollRestore";
import {useWarehouseState} from "../WarehouseContext";
import SearchIcon from "@mui/icons-material/Search";
import {FixedSizeList} from "react-window";
import useWindowDimensions from "../Dimension";
import {getBuyCond, isPurchased, textColorByPurchaseState, textDecorationByPurchaseState} from "../osp_utils";
import {useMeasure} from "react-use";



const LIST_HEIGHT = 194
// const TOOL_BUTTON_HEIGHT = 64
const MAX_WIDTH = 480
const LIST_MARGIN_HEIGHT = 235
const SAVE_SCROLL_KEY = 'money_list_scrollY'

export default function Monetization() {
  // const location = useLocation()
  const warehouseState = useWarehouseState()
  const history = useHistory()
  const listRef = useRef(null)
  // const [listParentRef, { height: listHeight }] = useMeasure();
  const [toolbarRef, { height: toolbarHeight }] = useMeasure();

  const [searchText, setSearchText] = useState('')
  const { windowHeight, windowWidth } = useWindowDimensions();

  const { lastScrollY, clearLastScrollY } = useScrollRestore({
    page: `monetization_list`,
    path: `/buy/monetization`
  });
  const match = useRouteMatch(history.location.pathname);

  const [requesting, setRequesting] = useState(false)
  const [list, setList] = useState([])
  const [results, setResults] = useState([])

  // const [message, setMessage] = useState(null)
  const [message, setMessage] = useState({
    text : '',
    error : false,
  })

  const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState(null)
  const statusMenuOpen = Boolean(statusMenuAnchorEl)

  const [dateMenuAnchorEl, setDateMenuAnchorEl] = useState(null)
  const [dateFilterName, setDateFilterName] = useState(()=>{
    let name = localStorage.getItem('lastDateFilterName')
    if(Boolean(name)){
      return name
    }
    return '지난90일'
  })
  const dateMenuOpen = Boolean(dateMenuAnchorEl)


  const [dateFilter, setDateFilter] = useState(()=>{
    let lastStartDate = localStorage.getItem('lastStartDateFilter')
    let lastEndDate = localStorage.getItem('lastEndDateFilter')
    console.log('init date start date : ' + lastStartDate + ', end date : ' + lastEndDate)
    if(Boolean(lastStartDate) && Boolean(lastEndDate)){
      console.log('restore date ' + new Date(lastStartDate) + ' ' + new Date(lastEndDate))
      return {
        startDate: new Date(lastStartDate),
        endDate: new Date(lastEndDate),
      }
    }
    return {
      startDate: startOfDay(addDays(new Date(), -90)),
      endDate: endOfDay(new Date()),
    }
  })

  // const [openTaxReqDialog, setOpenTaxReqDialog] = useState(false)

  const [dialog, setDialog] = useState({
    open : false,
    message : '',
    type : -1, // 0 : 정산요청 , 1 : 정산요청 취소
  })

  const [snackbar, setSnackbar] = useState({
    open : false,
    message : '',
  })

  const [customDateRange, setCustomDateRange] = useState([null, null]);
  const [openCustomRangeDialog, setOpenCustomRangeDialog] = useState(false)
  const [isCustomRangeFilterAvailable, setCustomRangeFilterAvailable] = useState(false)

  const [isSelectedAll, setIsSelectedAll] = useState(false)
  const [selectedList, setSelectedList] = useState(new Map())

  const [taxState, setTaxState] = useState(()=>{
    let state = localStorage.getItem('lastTaxStateFilter')
    if(Boolean(state)){
      return state
    }
    return 'possible'
  })

  const closeDialog = () =>{
    setDialog({...dialog, open: false})
  }

  const getTaxFilterName = (val) => {
    if(val === 'possible') {
      return "정산가능"
    }else if(val === 'impossible'){
      return "정산불가능"
    }else if(val === 'completed'){
      return "정산됨"
    }else if(val === 'processing'){
      return "정산중"
    }
  }

  const [taxStateName, setTaxStateName] = useState(()=>{
    const state = localStorage.getItem('lastTaxStateFilter')
    if(Boolean(state)){
      return getTaxFilterName(state)
    }
    return '정산가능'
  })

  const requestCardTax = () => {
    closeDialog()
    setRequesting(true)
    axios.post(`${process.env.REACT_APP_API_HOST}/osbuy/tax/request`, {
      // headers: {
      //   'Content-type': 'application/x-www-form-urlencoded',
      // },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        purchase_cart_ids: Array.from(selectedList.keys()),
        request : 'Y',
      }
    }).then((resp) => {

      console.log(resp)
      setRequesting(false)

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        console.log("result ", resp.data['results'])

        setSnackbar({
          open: true,
          message: "정산요청이 완료되었습니다.",
          error: false,
        })
        // setSelectedList(new Map())
        // setIsSelectedAll(false)

        requestBuy()
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else{
        setSnackbar({
          open: true,
          message: "정산요청을 실패 했습니다.",
          error: true,
        })
      }


    }).catch((e)=>{
      setSnackbar({
        open: true,
        message: "정산요청을 실패 했습니다.",
        error: true,
      })
      setRequesting(false)
    })

  }

  const cancelRequestCardTax = () => {
    closeDialog()
    setRequesting(true)
    axios.post(`${process.env.REACT_APP_API_HOST}/osbuy/tax/request`, {
      // headers: {
      //   'Content-type': 'application/x-www-form-urlencoded',
      // },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        purchase_cart_ids: Array.from(selectedList.keys()),
        request : 'N',
      }
    }).then((resp) => {

      console.log(resp)
      setRequesting(false)

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        console.log("result ", resp.data['results'])
        requestBuy()
        setSnackbar({
          open: true,
          message: "정산요청 취소가 완료되었습니다.",
          error: false,
        })
        setSelectedList(new Map())
        setIsSelectedAll(false)
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else{
        setSnackbar({
          open: true,
          message: "정산요청 취소에 실패 했습니다.",
          error: true,
        })
      }


    }).catch((e)=>{
      setSnackbar({
        open: true,
        message: "정산요청을 실패 했습니다.",
        error: true,
      })
      setRequesting(false)
    })
  }

  const setCustomRangeFilter = () => {
    setOpenCustomRangeDialog(false)
    setDateFilter({
      startDate : customDateRange[0],
      endDate : customDateRange[1],
    })
    setDateFilterName('맞춤설정')
  }

  const getTaxStateChip = (item) =>{
    if(item.card_tax_yn === 'Y') {
      return <Chip size={'small'} icon={<Done/>} label="정산됨" color={'success'}/>
    }else if(item.card_tax_req_yn === 'Y') {
      return <Chip size={'small'} label="정산중" color={'primary'} />
    }else if(item.card_tax_yn === 'Y'){
      return <Chip size={'small'} icon={<Done/>} label="정산완료"  color={'success'} />
    }else if(item.recv_complete === 'Y' && item.card_tax_req_yn === 'N'){
      return <Chip size={'small'} label="정산가능" color={'info'} />
    }else{
      return <Chip size={'small'} label="정산불가능"/>
    }
  }

  const getRecvStateChip = (item) =>{

    if(item.recv_complete === 'Y'){
      return <Chip sx={{ml : 0.5}} size={'small'} icon={<Done/>} label="입고완료"  color={'success'} />
    }else{
      return <Chip sx={{ml : 0.5}} size={'small'} label="입고안됨" />
    }
  }

  const requestBuy = () => {
    console.log("request buy " + taxState)
    console.log('date ', dateFilter)
    setSelectedList(new Map())
    setIsSelectedAll(false)
    setRequesting(true)
    setMessage({text: '', error: false})
    setSearchText("")
    setList([])
    setResults([])
    axios.get(`${process.env.REACT_APP_API_HOST}/osbuy`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        cardTaxState : taxState,
        startDate : moment(dateFilter.startDate).format('YYYY/MM/DD'),
        endDate : moment(dateFilter.endDate).format('YYYY/MM/DD'),
      },

    }).then((resp)=>{
      // console.log(resp)
      setRequesting(false)

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        if(resp.data['results'].length > 0){
          // let test = []
          // for (let i = 0 ; i < 200 ; ++i){
          //   test = test.concat(resp.data['results'])
          // }
          // console.log(test.length)
          // setList(test)


          console.log("results ", resp.data['results'].length);
          // // let data = resp.data['results']
          // let data = []
          // for (let i = 0 ; i < 50 ; ++i){
          //   data = data.concat(resp.data['results'])
          // }
          // setList(data)
          setList(resp.data['results'])
          setResults(resp.data['results'])
          restoreScroll()

          return;

        }else{
          setMessage({text : '조건에 맞는 내역이 없습니다.', error : false})
        }
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else{
        console.error(resp)
        setMessage({
          text : "에러가 발생했습니다. 잠시후 다시 이용해보세요",
          error: true
        })
      }

      localStorage.removeItem(SAVE_SCROLL_KEY);

    }).catch((e)=>{
      console.error(e)
      setMessage({
        text : "에러가 발생했습니다. 잠시후 다시 이용해보세요",
        error: true
      })
      setRequesting(false)
      localStorage.removeItem(SAVE_SCROLL_KEY);
    })

  }

  // useEffect(()=>{
  //
  //   return (()=>{
  //     // localStorage.setItem(`lastDateFilter`, dateFilter)
  //     console.log('save filter ' + taxState)
  //     localStorage.setItem(`lastTaxStateFilter`, taxState)
  //   })
  // }, [])

  const getToolButton = () => {
    let total_fees = 0
    let total_count = 0
    let total_payment = 0
    let total_tax_free = 0


    for(let buy of selectedList.values()){
      console.log('buy ', buy)
      for(let purchase of buy.purchase){
        total_fees += Math.round((1 / purchase.calc_base) * purchase.count * 200)
        total_count += purchase.count
      }
      if(buy.tax_free === 'Y'){
        total_tax_free += buy.purchase_total_price
      }else{
        total_payment += buy.purchase_total_price
      }
    }

    const purchaseCardNameMap = new Map()
    for(let buy of selectedList.values()){
      const purchaseCardName = buy.purchase_card_name
      const purchaseTotalPrice = buy.purchase_total_price
      if(purchaseCardNameMap.has(purchaseCardName)){
        purchaseCardNameMap.set(purchaseCardName, purchaseCardNameMap.get(purchaseCardName) + purchaseTotalPrice)
      }else{
        purchaseCardNameMap.set(purchaseCardName, purchaseTotalPrice)
      }
    }

    console.log('purchaseCardNameMap ', purchaseCardNameMap)
    console.log('total fees ' + total_fees)
    if(taxState === 'completed' || taxState === 'impossible'){
      if(selectedList.size === 0) {
        return <Box sx={{display : 'flex', width : '100%', justifyContent : 'center', py : 1, alignItems : 'center', backgroundColor : 'gray', color : 'white'}}>
            <Box>
              {`항목을 선택 하시면 금액을 확인 하실수 있습니다.`}
            </Box>
        </Box>
      }else{
        return <Box sx={{display : 'flex', flexDirection : 'column', width : '100%', py : 1, justifyContent : 'center', alignItems : 'center', backgroundColor : 'black', color : 'white'}}>
            <Box>
              {`일반 : ${total_payment.toLocaleString()}원 / 면세 : ${total_tax_free.toLocaleString()}원`}
            </Box>
            <Box>
              {`수수료 ${total_fees.toLocaleString()}원 / 상품수 ${total_count}개`}
            </Box>
            <Box sx = {{display : 'flex', flexDirection : 'row', textAlign : 'center', mt : 0.5, mx : 1, px : 0.5, py : 0.5, outline : '1px solid white'}}>
              {Array.from(purchaseCardNameMap.entries()).map(([key, value]) => (
                // <div key={key}>{`${key} : ${value.toLocaleString()}원`}</div>
                `${key} : ${value.toLocaleString()}원`
              )).join(', ')}
            </Box>
        </Box>
      }


    }else if(taxState === 'possible'){
      // let total_fees = 0
      // let total_count = 0
      // let total_payment = 0
      //
      // for(let buy of selectedList.values()){
      //   for(let purchase of buy.purchase){
      //     total_fees += Math.round((1 / purchase.calc_base) * purchase.count) * 200
      //     total_count += purchase.count
      //   }
      //   total_payment += buy.purchase_total_price;
      // }
      // console.log('total fees ' + total_fees)


      // setTaxData({
      //   totalFees: total_fees,
      //   totalPayment: total_payment,
      //   totalCount: total_count
      // })

      return <Button
          disabled={selectedList.size === 0}
          fullWidth
          sx={{p:0}}
          aria-multiline={false}
          onClick={()=>{
            setDialog({
              open : true,
              message: "정산요청 하시겠습니까?",
              type: 0
            })
          }}
          color={"secondary"}
          variant={"contained"}
          endIcon={<ArrowForwardIos sx={{mr : 1}}/>}
        >
          <Box sx={{display : 'flex', fontSize : 15, flexDirection : 'row', width : '100%', justifyContent : 'center', alignItems : 'center', py : 1}}>

            {selectedList.size === 0 ?
              ""
              :
              // `총 ${total_count}개 ${total_payment.toLocaleString()}원, (수수료 ${total_fees.toLocaleString()}원)`
              <Box sx={{display : 'flex', flexDirection : 'column', mr : 2, flexGrow : 1}}>
                <Box>
                  {`일반 : ${total_payment.toLocaleString()}원 / 면세 : ${total_tax_free.toLocaleString()}원`}
                </Box>
                <Box>
                  {`수수료 ${total_fees.toLocaleString()}원 / 상품수 ${total_count}개`}
                </Box>
                <Box sx = {{display : 'flex', flexDirection : 'row', textAlign : 'center', mt : 0.5, mx : 1, px : 0.5, py : 0.5, outline : '1px solid white'}}>
                  {Array.from(purchaseCardNameMap.entries()).map(([key, value]) => (
                    // <div key={key}>{`${key} : ${value.toLocaleString()}원`}</div>
                    `${key} : ${value.toLocaleString()}원`
                  )).join(', ')}
                </Box>
              </Box>
            }
            <Box sx={{width : 160, textAlign : 'center'}}>
              {"정산요청"}
            </Box>
          </Box>
        </Button>



    }else if(taxState === 'processing'){
      return <Button
        disabled={selectedList.size === 0}
        sx={{p:0}}
        fullWidth
        aria-multiline={false}
        onClick={()=>{
          setDialog({
            open : true,
            message: "정산요청을 취소 하시겠습니까?",
            type: 1
          })
        }}
        color={"warning"}
        variant={"contained"}
        endIcon={<ArrowForwardIos sx={{mr : 1}}/>}
      >

        <Box sx={{display : 'flex', flexDirection : 'row', fontSize : 15, width : '100%', py : 1,
          justifyContent : 'center', alignItems : 'center'}}>
          {selectedList.size === 0 ?
            ""
            :
            // `총 ${total_count}개 ${total_payment.toLocaleString()}원, (수수료 ${total_fees.toLocaleString()}원)`
            <Box sx={{display : 'flex', flexDirection : 'column', mr : 2, flexGrow: 1, }}>
              <Box>
                {`일반 : ${total_payment.toLocaleString()}원 / 면세 : ${total_tax_free.toLocaleString()}원`}
              </Box>
              <Box>
                {`수수료 ${total_fees.toLocaleString()}원 / 상품수 ${total_count}개`}
              </Box>
              <Box sx = {{display : 'flex', flexDirection : 'row', textAlign : 'center', mt : 0.5, mx : 1, px : 0.5, py : 0.5, outline : '1px solid white'}}>
                {Array.from(purchaseCardNameMap.entries()).map(([key, value]) => (
                  // <div key={key}>{`${key} : ${value.toLocaleString()}원`}</div>
                  `${key} : ${value.toLocaleString()}원`
                )).join(', ')}
              </Box>
            </Box>
          }
          <Box sx={{width : 160, textAlign : 'center'}}>
            {"요청취소"}
          </Box>
        </Box>
      </Button>
    }

    return null
  }

  const listRow = ({index , style}) => {
    const item = list[index]
    return <div key={index} style={{...style, display : 'flex', flexDirection : 'column', alignItems : 'center', }}>
        <ListItem
          key={index}
          sx={{
            // color : '#22222240',
            height : '100%',
            maxWidth : MAX_WIDTH,
            pl: 0,
            // alignItems : 'stretch',
            backgroundColor : 'white'
          }}
          component={"div"}
        >
          <Checkbox
            sx={{pl : 2, pr : 2}}
            checked={selectedList.has(item.purchase_cart_id)}
            // checked={selectedTestList.includes(item.purchase_cart_id)}
            onChange={(e, v)=>{
              console.log( v + ' ', item)
              setSelectedList((prev) => {
                let newState
                if(v){
                  newState = new Map([...prev, [item.purchase_cart_id, item]])
                }else{
                  newState = new Map(prev);
                  newState.delete(item.purchase_cart_id);
                }

                if(newState.size === list.length){
                  setIsSelectedAll(true)
                }else{
                  setIsSelectedAll(false)
                }
                return newState
              })
            }} />
          <Box sx={{ width : '100%'}}>
            <Box
              onClick={()=> history.push('/detail', {buy : item,})}
            >
              <Box sx={{
                // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                fontWeight: 'medium',
                mt : 1
              }}>
                {moment(new Date(item.purchase_date)).format('YYYY/MM/DD HH:mm') + ' 에 구매'}
              </Box>
              <Box sx={{
                // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                fontWeight: 'medium',
                width : (windowWidth > MAX_WIDTH) ? 410 : windowWidth - 70,
                textOverflow : 'ellipsis',
                whiteSpace : 'nowrap',
                overflow : 'hidden',
                wordWrap : 'normal',
                mt : 1
              }}>
                {'카드 - ' + item.purchase_card_name + ', 조건 - ' + getBuyCond(item)}
              </Box>
              <Box sx={{
                // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                fontWeight: 'medium',
                width : (windowWidth > MAX_WIDTH) ? 410 : windowWidth - 70,
                textOverflow : 'ellipsis',
                whiteSpace : 'nowrap',
                overflow : 'hidden',
                wordWrap : 'normal',
                mt : 1
              }}>
                {'링크 - ' + item.shop_name}
              </Box>
              <Box sx={{
                // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
                // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
                fontWeight: 'medium',
                mt : 1
              }}>
                {getPurchaseNameSummary(item.purchase)}
              </Box>
              {/*<Box*/}
              {/*  sx={{*/}
              {/*    // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),*/}
              {/*    marginTop : 1,*/}
              {/*    paddingBottom : 1,*/}
              {/*    // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'success.dark'),*/}
              {/*    display: 'flex',*/}
              {/*    flexGrow: 1,*/}
              {/*    fontWeight: 'medium',*/}
              {/*    justifyContent: 'flex-end',*/}
              {/*    fontSize : 24,*/}
              {/*  }}*/}
              {/*>*/}
              {/*  {item.purchase_total_price.toLocaleString() + '원'}*/}
              {/*</Box>*/}
            </Box>
            <Box sx={{
              display : 'flex',
              flexDirection: 'row',
              alignItems : 'center',
              justifyContent : 'flex-end',
              mt : 1,
            }}>
              {
                getTaxStateChip(item)
              }
              {
                getRecvStateChip(item)
              }
              <Box
                sx={{
                  ml:1,
                  display: 'flex',
                  fontWeight: 'medium',
                  fontSize : 23,
                }}
              >
                {item.purchase_total_price.toLocaleString() + '원'}
              </Box>
            </Box>
          </Box>


        </ListItem>
        <Divider />
      {/*</Box>*/}

    </div>
  }

  // const renderList = useMemo(()=>{
  //   return (
  //     <List sx={{ width: '100%', maxWidth: 480}}>
  //       {
  //         list.map((item, index)=>(
  //           <ListItem
  //             key={index}
  //             sx={{
  //               // color : '#22222240',
  //               display : "flex",
  //               mt: ((index === 0) ? 0 : 1),
  //               pl: 0,
  //               alignItems : 'stretch',
  //             }}
  //             component={Paper}
  //           >
  //             <Checkbox
  //               sx={{pl : 2, pr : 2}}
  //               checked={selectedList.has(item.purchase_cart_id)}
  //               // checked={selectedTestList.includes(item.purchase_cart_id)}
  //               onChange={(e, v)=>{
  //                 console.log( v + ' ', item)
  //                 setSelectedList((prev) => {
  //                   let newState
  //                   if(v){
  //                     newState = new Map([...prev, [item.purchase_cart_id, item]])
  //                   }else{
  //                     newState = new Map(prev);
  //                     newState.delete(item.purchase_cart_id);
  //                   }
  //
  //                   if(newState.size === list.length){
  //                     setIsSelectedAll(true)
  //                   }else{
  //                     setIsSelectedAll(false)
  //                   }
  //                   return newState
  //                 })
  //               }} />
  //
  //             <Box sx={{ flexBasis : 1, flexGrow : 1}}
  //               onClick={()=> history.push('/detail', {buy : item,})}
  //             >
  //               <Box sx={{
  //                 // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
  //                 // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
  //                 fontWeight: 'medium',
  //                 mt : 1
  //               }}>
  //                 {moment(new Date(item.purchase_date)).format('YYYY/MM/DD HH:mm') + ' 에 구매'}
  //               </Box>
  //               <Box sx={{
  //                 // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
  //                 // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
  //                 fontWeight: 'medium',
  //                 mt : 1
  //               }}>
  //                 {'결제카드 - ' + item.purchase_card_name}
  //               </Box>
  //               <Box sx={{
  //                 // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
  //                 // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'text.primary'),
  //                 fontWeight: 'medium',
  //                 mt : 1
  //               }}>
  //                 {getPurchaseNameSummary(item.purchase)}
  //               </Box>
  //               <Box
  //                 sx={{
  //                   // textDecorationLine: ((item.purchase_yn === 'Y') ? 'line-through' : 'none'),
  //                   marginTop : 1,
  //                   paddingBottom : 1,
  //                   // color: ((item.purchase_yn === 'Y') ?'#00000033' : 'success.dark'),
  //                   display: 'flex',
  //                   flexGrow: 1,
  //                   fontWeight: 'medium',
  //                   justifyContent: 'flex-end',
  //                   fontSize : 24,
  //                 }}
  //               >
  //                 {item.purchase_total_price.toLocaleString() + '원'}
  //               </Box>
  //             </Box>
  //             <Box sx={{
  //               // width : 110,
  //               // height : '100%',
  //               //  flexBasis: 1,
  //               display : 'flex',
  //               flexDirection: 'column',
  //               // alignItems : 'flex-start',
  //               alignItems : 'stretch',
  //               pl: 2
  //             }}>
  //               <Box
  //                 sx={{
  //                   display : 'flex',
  //                   flexGrow: 1,
  //                   fontWeight: 'medium',
  //                   alignItems: 'flex-start',
  //                   justifyContent : 'flex-end',
  //                   fontSize : 13,
  //                 }}
  //               >
  //                 {
  //                   getTaxStateChip(item)
  //                 }
  //                 {/*<Chip icon={<Done/>} label="정산요청" />*/}
  //               </Box>
  //               <Box
  //                 sx={{
  //                   display : 'flex',
  //                   flexGrow: 1,
  //                   fontWeight: 'medium',
  //                   alignItems: 'flex-end',
  //                   justifyContent : 'flex-end',
  //                   fontSize : 13,
  //                 }}
  //               >
  //                 {
  //                   getRecvStateChip(item)
  //                 }
  //                 {/*<Chip icon={<Done/>} label="입고됨" />*/}
  //               </Box>
  //             </Box>
  //
  //           </ListItem>
  //         ))
  //       }
  //     </List>
  //   )
  // }, [list, selectedList])

  useEffect(() => {
    // console.log('lastScrollY ', lastScrollY)
    // console.log('clearLastScrollY ', clearLastScrollY)
    // console.log('match ', match)

    if (lastScrollY && match?.isExact) {
      console.log('set last scroll ' + lastScrollY)
      window.scrollTo(0, lastScrollY);
      const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      // clearLastScrollY();

      if (scrollTop === Number(lastScrollY)) {
        clearLastScrollY();
      }
    }
  }, [lastScrollY, match]);

  const restoreScroll = () => {
    let lastScrollY = localStorage.getItem(SAVE_SCROLL_KEY);
    console.log('restore lastScrollY', lastScrollY)
    if (listRef && listRef.current && lastScrollY) {
      listRef.current.scrollTo(lastScrollY);
      window.scrollTop = 0
      // window.innerHeight = windowHeight
      // window.scrollBy(0, 0);
      window.scrollTo(0, 0);
      localStorage.removeItem(SAVE_SCROLL_KEY);
    }
  }

  useEffect(()=>{
    // console.log('restore ' , localStorage.getItem('lastStartDateFilter'))
    requestBuy()
    localStorage.removeItem(`lastTaxStateFilter`)
    localStorage.removeItem(`lastStartDateFilter`)
    localStorage.removeItem(`lastEndDateFilter`)
    localStorage.removeItem(`lastDateFilterName`)
    return (()=>{
      console.log('save filter ' + taxState + ' ' + dateFilter.startDate + ' ' + dateFilter.endDate)
      localStorage.setItem(`lastTaxStateFilter`, taxState)
      localStorage.setItem(`lastStartDateFilter`, dateFilter.startDate)
      localStorage.setItem(`lastEndDateFilter`, dateFilter.endDate)
      localStorage.setItem(`lastDateFilterName`, dateFilterName)

      console.log('save lastScrollY ', window.scrollPosition)
      localStorage.setItem(SAVE_SCROLL_KEY, window.scrollPosition);
    })
  }, [taxState, dateFilter])

  const closeStatusMenu = () => {
    setStatusMenuAnchorEl(null);
  };

  const selectStateMenu = (event, val) => {
    console.log(val)
    closeStatusMenu()
    setTaxState(val);
    setTaxStateName(getTaxFilterName(val))

  };

  const closeDateMenu = () => {
    setDateMenuAnchorEl(null);
  };

  const selectDateMenu = (event, val) => {
    console.log(val)
    closeDateMenu()

    if(val === '맞춤설정'){
      setCustomDateRange([null, null])
      setCustomRangeFilterAvailable(false)
      setOpenCustomRangeDialog(true)
      return
    }

    setDateFilterName(val)
    if(val === '오늘'){
      setDateFilter({
        startDate: startOfDay(new Date()),
        endDate: endOfDay(new Date()),
      })
    }else if(val === '어제'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -1)),
        endDate: endOfDay(addDays(new Date(), -1)),
      })
    }else if(val === '이번주'){
      setDateFilter({
        startDate: startOfWeek(new Date()),
        endDate: endOfWeek(new Date()),
      })
    }else if(val === '지난주'){
      setDateFilter({
        startDate: startOfWeek(addDays(new Date(), -7)),
        endDate: endOfWeek(addDays(new Date(), -7)),
      })
    }else if(val === '이번달'){
      setDateFilter({
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date()),
      })
    }else if(val === '지난달'){
      setDateFilter({
        startDate: startOfMonth(addMonths(new Date(), -1)),
        endDate: endOfMonth(addMonths(new Date(), -1)),
      })
    }else if(val === '지난7일'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -7)),
        endDate: endOfDay(new Date()),
      })
    }else if(val === '지난28일'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -28)),
        endDate: endOfDay(new Date()),
      })

    }else if(val === '지난30일'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -30)),
        endDate: endOfDay(new Date()),
      })
    }else if(val === '지난90일'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -90)),
        endDate: endOfDay(new Date()),
      })
    }else if(val === '지난120일'){
      setDateFilter({
        startDate: startOfDay(addDays(new Date(), -120)),
        endDate: endOfDay(new Date()),
      })
    }

  };

  // useEffect(()=>{
  //   setCardTaxAvailable(selectedList.size > 0)
  // },[selectedList])

  return (
    <Box sx={{
      // p : 0,
      // m : 0,
      // backgroundColor: (theme) => theme.palette.grey[100],
      flexGrow : 1,
      height : '100%',
      // backgroundColor : 'red',
      display : 'flex', width : '100%', justifyContent : 'center'}}>
      {
        requesting ?
          <ProgressDiv>
            <CircularProgress size={34} thickness={4}/>
          </ProgressDiv>
          :
          <Box sx={{display : 'flex', flexDirection : 'column', alignItems : 'center', m : 0, p : 0, width : '100%'}}>
            <Search sx={{maxHeight : 48, height : 48, maxWidth : MAX_WIDTH, width : '100%'}}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                value={searchText}
                onKeyUp={(e) => {
                  if(e.key === "Enter"){
                    e.target.blur()
                  }
                }}
                onChange={(e)=>{

                  // console.log("onChange " + e.target.value )
                  let value = e.target.value
                  setSearchText(value)
                  if(value && value.length > 0){
                    const compareValue = getComparableText(value);
                    setList(results.filter((item) => {
                      if(item && item.purchase){
                        for(let p of item.purchase){
                          if(p.buy_cond && getComparableText(p.buy_cond).includes(compareValue)){
                            return true;
                          }
                        }
                      }
                      if(item.purchase_card_name && getComparableText(item.purchase_card_name).includes(compareValue)){
                        return true;
                      }
                      if(item.shop_name && getComparableText(item.shop_name).includes(compareValue)){
                        return true;
                      }
                      for(let purchase of item.purchase){
                         if(purchase.name && getComparableText(purchase.name).includes(compareValue)){
                           return true;
                         }
                      }

                      return false;
                    }))
                  }else{
                    setList(results)
                  }

                }}
                placeholder="상품명/링크/카드/결재조건으로 검색..."
                endAdornment={
                  <InputAdornment position="end">
                    {
                      searchText && searchText.length > 0 ?
                        <IconButton
                          sx={{mr : 1}}
                          onClick={()=>{
                            setSearchText("")
                            setList(results)
                            listRef?.current?.scrollTo(0)
                          }}
                          edge="end"
                        >
                          <ClearRounded/>
                        </IconButton>
                        :
                        <div/>
                    }
                  </InputAdornment>
                }
              />

            </Search>
            <Box sx={{display : "flex", maxWidth : MAX_WIDTH, width : '100%'}}>
              <Checkbox
                disabled={list.length === 0 || Boolean(message.text)}
                checked={isSelectedAll}
                onChange={(e, v)=>{
                  if(v){
                    setIsSelectedAll(true)
                    //  console.log("start new selected")
                    // let newSelected = new Map(list.map((v) => [v.purchase_cart_id, v]))
                    //  console.log("end new selected")
                    // setSelectedList(newSelected)
                    setSelectedList(new Map(list.map((v) => [v.purchase_cart_id, v])))
                    // setSelectedTestList(list.map(l => l.purchase_id))
                  }else{
                    setIsSelectedAll(false)
                    setSelectedList(new Map())
                    // setSelectedTestList([])
                  }
                }}
                sx={{pl : 2, pr : 2}}/>
              {
                selectedList.size === 0 ?
                  <Button
                    disabled={true}
                    sx={{flexGrow : 1}}
                    startIcon={<Download/>}>
                    다운로드
                  </Button>
                  :
                <CsvDownloader
                  style={{display : 'flex', flexGrow : 1}}
                  filename={"folsn_download"}
                  datas={()=>{
                    const target = []
                    for(let item of list){
                      console.log('download ' + item.dest + ' ' + item.purchase_cart_id + ' ' + selectedList.has(item.purchase_cart_id))
                      if(selectedList.has(item.purchase_cart_id)) {
                        target.push({
                          "구매일" : moment(new Date(item.purchase_date)).format('YYYY/MM/DD HH:mm'),
                          "요청금액" : item.total_price,
                          "결제금액" : item.purchase_total_price,
                          "결제카드" : item.purchase_card_name,
                          "조건" : item.cond,
                          "마켓이름" : item.shop_name,
                          "배송지" : getWarehouseNameFromState(parseInt(item.dest), warehouseState),
                          "입고상태" : item.recv_complete,
                          "정산상태" : item.card_tax_yn,
                          "정산요청" : item.card_tax_req_yn,
                          "면세" : item.tax_free,
                          "상품명" : getPurchaseNameForDownload(item.purchase),
                        })
                      }
                    }

                    return target;
                  }}>
                  <Button
                    sx={{flexGrow : 1}}
                    startIcon={<Download/>}>
                    다운로드
                  </Button>
                </CsvDownloader>
              }

              <Button
                sx={{flexGrow : 1}}
                // style={{height: 50, minWidth: 80}}
                aria-multiline={false}
                onClick={(event)=>{
                  setDateMenuAnchorEl(event.target)
                }}
                variant={"text"}
                endIcon={<ArrowDropDownOutlined/>}
              >
                {dateFilterName}
              </Button>
              <Menu
                id="date-menu"
                anchorEl={dateMenuAnchorEl}
                open={dateMenuOpen}
                onClose={closeDateMenu}
              >
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "오늘")}>오늘</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "어제")}>어제</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "이번주")}>이번주</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난주")}>지난주</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "이번달")}>이번달</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난달")}>지난달</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난7일")}>지난7일</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난28일")}>지난28일</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난30일")}>지난30일</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난90일")}>지난90일</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "지난120일")}>지난120일</MenuItem>
                <MenuItem onClick={(ev)=>selectDateMenu(ev, "맞춤설정")}>맞춤설정</MenuItem>
              </Menu>
              <Button
                sx={{alignContent : 'flex-end', flexGrow : 1}}
                // style={{height: 50, minWidth: 80}}
                aria-multiline={false}
                onClick={(event)=>{
                  setStatusMenuAnchorEl(event.target)
                }}
                variant={"text"}
                endIcon={<ArrowDropDownOutlined/>}
              >
                {taxStateName}
              </Button>
              <Menu
                id="state-menu"
                anchorEl={statusMenuAnchorEl}
                open={statusMenuOpen}
                onClose={closeStatusMenu}
              >
                <MenuItem onClick={(ev)=>selectStateMenu(ev, "possible")}>정산가능</MenuItem>
                <MenuItem onClick={(ev)=>selectStateMenu(ev, "impossible")}>정산불가능</MenuItem>
                <MenuItem onClick={(ev)=>selectStateMenu(ev, "completed")}>정산됨</MenuItem>
                <MenuItem onClick={(ev)=>selectStateMenu(ev, "processing")}>정산중</MenuItem>
              </Menu>
            </Box>
            {
              Boolean(message.text) ?
                <Box sx={{
                  pt : 12,
                  backgroundColor: (theme) => theme.palette.grey[100],
                  flexGrow : 1,
                  flexDirection : 'column',
                  display : 'flex', width : '100%', justifyContent : 'center', alignItems : 'center'}}>
                  {message.error ? <InfoSharp color={'error'}/> : <div/>}
                  <Box
                    sx={{mt : 2}}
                  >
                    {message.text}
                  </Box>
                  {/*{message.error ?*/}
                  {/*  <Button*/}
                  {/*    sx={{mt : 6}}*/}
                  {/*    variant={"outlined"}*/}
                  {/*    color={"secondary"}>*/}
                  {/*    다시시도*/}
                  {/*  </Button>*/}
                  {/*  : <div/>}*/}
                </Box>
                :
                <Box sx={{display : 'flex', flexDirection : 'column', alignItems : 'center', maxWidth : MAX_WIDTH, width : '100%', flexGrow : 1}}>
                  <Box ref={toolbarRef} sx={{display : 'flex', width : '100%', justifyContent : 'center'}} >
                    {getToolButton()}
                  </Box>

                  {/*{renderList}*/}
                  <Box sx={{height : 6}}/>
                  <Box sx={{display : 'flex', flexDirection : 'column', width : '100%', alignItems : 'center', flexGrow : 1}}>
                      <FixedSizeList
                        ref={listRef}
                        onScroll={scroll => {
                          // console.log("onScroll", scroll.scrollOffset);
                          window.scrollPosition = scroll.scrollOffset;
                        }}
                        itemCount={list.length}
                        // height={240}
                        height={windowHeight - toolbarHeight - LIST_MARGIN_HEIGHT}
                        width={windowWidth}
                        itemSize={LIST_HEIGHT}
                        itemData={list}
                        style={{
                          padding : 0,
                          // flexGrow : 1
                        }}>
                        {listRow}
                      </FixedSizeList>
                    {/*<AutoSizer*/}
                    {/*>*/}
                    {/*  {({width, height}) => (*/}
                    {/*  <FixedSizeList*/}
                    {/*    ref={listRef}*/}
                    {/*    onScroll={scroll => {*/}
                    {/*      // console.log("onScroll", scroll.scrollOffset);*/}
                    {/*      window.scrollPosition = scroll.scrollOffset;*/}
                    {/*    }}*/}

                    {/*    itemCount={list.length}*/}
                    {/*    height={height}*/}
                    {/*    width={width}*/}
                    {/*    itemSize={LIST_HEIGHT}*/}
                    {/*    itemData={list}*/}
                    {/*    style={{*/}
                    {/*      padding : 0,*/}
                    {/*      flexGrow : 1*/}
                    {/*    }}>*/}
                    {/*    {listRow}*/}
                    {/*  </FixedSizeList>*/}
                    {/*)}*/}
                    {/*</AutoSizer>*/}

                  </Box>
                </Box>
            }
           <Dialog
              open={openCustomRangeDialog}
              onClose={()=>setOpenCustomRangeDialog(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"맞춤설정"}
              </DialogTitle>
              <DialogContent>
                <MobileDateRangePicker
                  startText="시작"
                  endText="끝"
                  value={customDateRange}
                  onChange={(newValue) => {
                    console.log(newValue)
                    if(newValue.length === 2 && newValue[0] != null && newValue[1] != null){
                      setCustomRangeFilterAvailable(true)
                    }else{
                      setCustomRangeFilterAvailable(false)
                    }
                    setCustomDateRange(newValue);

                  }}
                  renderInput={(startProps, endProps) => (
                    <Box sx={{height : 120, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                      <TextField {...startProps} />
                      <Box sx={{ mx: 2 }}> to </Box>
                      <TextField {...endProps}/>
                    </Box>
                  )}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>setOpenCustomRangeDialog(false)}>취소</Button>
                <Button disabled={!isCustomRangeFilterAvailable} onClick={()=>setCustomRangeFilter()}>
                  적용
                </Button>
              </DialogActions>
            </Dialog>

          </Box>


      }
      <Dialog
        // fullWidth
        // maxWidth={maxWidth}
        open={dialog.open}
        onClose={()=>closeDialog()}
      >
        <DialogContent>
          <DialogContentText>
            {dialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            onClick={()=>closeDialog()}
          >
            취소
          </Button>
          <Button
            variant={"contained"}
            color={'success'}
            onClick={()=>{
              if(dialog.type === 0){
                requestCardTax()
              }else if(dialog.type === 1){
                cancelRequestCardTax()
              }

            }}>
            예
          </Button>
        </DialogActions>

      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={()=>setSnackbar({open : false, message: ''})}
        message={snackbar.message}
      />
      {/*<Backdrop*/}
      {/*  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}*/}
      {/*  open={requesting}*/}
      {/*  // onClick={handleClose}*/}
      {/*>*/}
      {/*  <CircularProgress color="inherit" />*/}
      {/*</Backdrop>*/}
    </Box>
  )
}

